export default "__VITE_ASSET__DYUd7ULo__"